<template>
  <v-container fluid fill-height pa-0>
    <v-layout align-column-center justify-center column>
      <v-card width="100%" color="transparent" flat>
        <v-parallax
          :height="`${this.secondHeight}`"
          :src="require('@/assets/background/9.jpg')"
          style="padding: 0px">
          <v-container fill-height fluid pa-0 style="background: #ffffffbf">
            <v-layout align-center justify-center column>
              <v-flex xs2 sm2 md2 lg2></v-flex>
              <v-flex xs2 sm2 md2 lg2>
                <v-card-text class="text-xs-center">
                  <span class="display-2 black--text font-weight-black">{{ $t('aboutTitle') }}</span>
                </v-card-text>
              </v-flex>
              <v-flex xs8 sm8 md8 lg8 class="pl-5 pr-5 ml-5 mr-5">
                <v-card-text class="pl-5 pr-5 ml-5 mr-5 black--text" style="text-align:center;">
                  <p class="subheading" v-html="$t('aboutParagraph')">
                  </p>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-container>
        </v-parallax>
      </v-card>
      <v-card width="100%" color="grey lighten-4" flat>
        <v-container fill-height>
          <v-layout column>
            <v-layout wrap row>
              <v-flex xs4 sm4 md4 lg4 class="pa-3"
                v-for="item in abouts"
                :key="item.id">
                <v-card class="white--text" color="grey darken-3">
                  <v-card-text>
                    <span class="headline font-weight-black"> {{ item.title }} </span>
                  </v-card-text>
                  <v-card-text class="pt-0" style="text-align: justify;">
                    <p> {{ item.content }} </p>
                    </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-card-text class="text-xs-center mt-3 mb-3">
              <span class="display-2 font-weight-black">{{ $t('teamTitle') }}</span>
            </v-card-text>
            <v-layout wrap row mb-3>
              <v-flex xs3 sm3 md3 lg3 class="pa-2"
                v-for="item in teams"
                :key="item.id">
                <v-card color="transparent">
                  <v-img aspect-ratio="0.75"
                    :src="require('@/assets/background/'+item.image)"></v-img>
                  <v-card-text class="text-xs-center">
                    <span class="subheading font-weight-bold mb-2">{{ item.name }} </span><br/>
                    <span>{{ item.position }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      windowHeight: 1000,
      secondHeight: 500,
      windowWidth: 500,
      abouts: [
        { id: 1, title: this.$i18n.t('visionTitle'), content: this.$i18n.t('visionDescription') },
        { id: 2, title: this.$i18n.t('missionTitle'), content: this.$i18n.t('missionDescription') },
        { id: 3, title: this.$i18n.t('coreValueTitle'), content: this.$i18n.t('coreValueDescription') }
      ],
      teams: [
        { id: 1, name: this.$i18n.t('memberName1'), position: this.$i18n.t('memberPosition1'), image: '2.jpg' },
        { id: 2, name: this.$i18n.t('memberName2'), position: this.$i18n.t('memberPosition2'), image: '9.jpg' },
        { id: 3, name: this.$i18n.t('memberName3'), position: this.$i18n.t('memberPosition3'), image: '13.jpg' },
        { id: 4, name: this.$i18n.t('memberName4'), position: this.$i18n.t('memberPosition4'), image: '11.jpg' }
      ]
    }
  },

  methods: {
    setSize () {
      this.windowHeight = window.innerHeight
      this.secondHeight = this.windowHeight * 0.75
      this.thirdHeight = this.windowHeight * 0.3
      this.windowWidth = window.innerWidth
    }
  },

  mounted () {
    this.setSize()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/About.vue